/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './accounting-currency.reducer';

export const AccountingCurrencyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const accountingCurrencyEntity = useAppSelector(state => state.accountingCurrency.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="accountingCurrencyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.accountingCurrency.detail.title">AccountingCurrency</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.id">Id</Translate>
            </span>
          </dt>
          <dd>{accountingCurrencyEntity.id}</dd>
          <dt>
            <span id="codeString">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.codeString">Code String</Translate>
            </span>
            <UncontrolledTooltip target="codeString">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.codeString" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.codeString}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.name">Name</Translate>
            </span>
            <UncontrolledTooltip target="name">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.name" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.name}</dd>
          <dt>
            <span id="code">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.code">Code</Translate>
            </span>
            <UncontrolledTooltip target="code">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.code" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.code}</dd>
          <dt>
            <span id="precision">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.precision">Precision</Translate>
            </span>
            <UncontrolledTooltip target="precision">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.precision" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.precision}</dd>
          <dt>
            <span id="subUnit">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.subUnit">Sub Unit</Translate>
            </span>
            <UncontrolledTooltip target="subUnit">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.subUnit" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.subUnit}</dd>
          <dt>
            <span id="symbol">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.symbol">Symbol</Translate>
            </span>
            <UncontrolledTooltip target="symbol">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.symbol" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.symbol}</dd>
          <dt>
            <span id="symbolFirst">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.symbolFirst">Symbol First</Translate>
            </span>
            <UncontrolledTooltip target="symbolFirst">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.symbolFirst" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.symbolFirst ? 'true' : 'false'}</dd>
          <dt>
            <span id="decimalMark">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.decimalMark">Decimal Mark</Translate>
            </span>
            <UncontrolledTooltip target="decimalMark">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.decimalMark" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.decimalMark}</dd>
          <dt>
            <span id="thousandsSeparator">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.thousandsSeparator">Thousands Separator</Translate>
            </span>
            <UncontrolledTooltip target="thousandsSeparator">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.thousandsSeparator" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.thousandsSeparator}</dd>
          <dt>
            <span id="country">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.country">Country</Translate>
            </span>
            <UncontrolledTooltip target="country">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.country" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.country}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.active">Active</Translate>
            </span>
            <UncontrolledTooltip target="active">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.active" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.cursor">Cursor</Translate>
            </span>
            <UncontrolledTooltip target="cursor">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.cursor" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.lastUpdated">Last Updated</Translate>
            </span>
            <UncontrolledTooltip target="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.lastUpdated" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.microSec">Micro Sec</Translate>
            </span>
            <UncontrolledTooltip target="microSec">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.microSec" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.timestampEntry">Timestamp Entry</Translate>
            </span>
            <UncontrolledTooltip target="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.accountingCurrency.help.timestampEntry" />
            </UncontrolledTooltip>
          </dt>
          <dd>{accountingCurrencyEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.accountingCurrency.account">Account</Translate>
          </dt>
          <dd>
            {accountingCurrencyEntity.accounts
              ? accountingCurrencyEntity.accounts.map((val, i) => (
                  <span key={val.id}>
                    <a>{val.id}</a>
                    {accountingCurrencyEntity.accounts && i === accountingCurrencyEntity.accounts.length - 1 ? '' : ', '}
                  </span>
                ))
              : null}
          </dd>
        </dl>
        <Button tag={Link} to="/accounting-currency" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/accounting-currency/${accountingCurrencyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AccountingCurrencyDetail;
